import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icons } from '../../../../../components/Common/Icons/Icons';
import PageHeader from '../../../Common/PageHeader';
import ContentCard from '../../../Common/Card';
import { cn } from '../../../../../utils/styles';
import MenuIcon from '../../../Layout/Menu/MenuIcon';
import AuthorizedViewersTable from './Data';
import { Button } from '../../../../../components/Common/UI/Button';

function AuthorizedViewers() {
  const [active, setActive] = useState<number | undefined>(0);
  const navigate = useNavigate();

  const handleActive = (index?: number) => {
    setActive(index);
  };

  return (
    <div>
      <PageHeader
        icon={<Icons.Users />}
        ignoreAccount
        title="Manage Authorized Viewers"
        disableDownloadBtn
        actions={
          <Button
            variant="default"
            className="bg-inherit border border-white text-white hover:bg-white/10"
            onClick={() => navigate('/guidance/create-authorized-viewers')}
          >
            <Icons.PlusFilled className="mr-2" />
            Create Viewer
          </Button>
        }
      />
      <div className={cn('px-[20px] grid gap-[20px]')}>
        <ContentCard
          title="Authorized Viewers"
          icon={
            <MenuIcon
              icon={<Icons.User />}
              className="bg-destructive border-destructive"
              variant="white"
              size="large"
            />
          }
          subTitle={
            <div className="pl-14 text-[16px] leading-5">
              The following is a list of viewers authorized to view your accounts. You can create up to 10 authorized
              viewers. To add a new viewer, click the Create Viewer button.
            </div>
          }
        >
          <AuthorizedViewersTable />
        </ContentCard>
      </div>
    </div>
  );
}

export default AuthorizedViewers;
